import React, { useState, useEffect } from "react";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";

const ImageCropper = (props) => {
  let cropper;

  const [state, setState] = useState({
    src: null,
    aspectRatio: {
      width: null,
      height: null,
    },
    cropResult: null,
  });

  const getImageDimensions = (image) => {
    const i = new Image();
    const aspectRatio = { ...state.aspectRatio };

    i.addEventListener("load", function () {
      aspectRatio.width = this.naturalWidth;
      aspectRatio.height = this.naturalHeight;

      return setState((state) => ({
        ...state,
        aspectRatio: aspectRatio,
      }));
    });

    i.src = image;
  };

  useEffect(() => {
    const defaultImage = props.defaultImage;

    getImageDimensions(defaultImage);
    setState((state) => ({
      ...state,
      src: defaultImage,
    }));

    return () => {
      const aspectRatio = { ...state.aspectRatio };

      aspectRatio.width = null;
      aspectRatio.height = null;

      setState((state) => ({
        ...state,
        aspectRatio: aspectRatio,
      }));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChange = (event) => {
    event.preventDefault();
    let files;

    if (event.dataTransfer) {
      files = event.dataTransfer.files;
    } else if (event.target) {
      files = event.target.files;
    }

    const reader = new FileReader();
    reader.onload = () => {
      getImageDimensions(reader.result);
      setState((state) => ({
        ...state,
        src: reader.result,
      }));
    };

    return reader.readAsDataURL(files[0]);
  };

  const cropImage = () => {
    if (typeof cropper.getCroppedCanvas() === "undefined") return;
    const image = cropper.getCroppedCanvas().toDataURL();

    setState((state) => ({
      ...state,
      cropResult: image,
    }));

    return props.imageCropHandler(image);
  };

  const useDefaultImage = () => {
    const defaultImage = props.defaultImage;

    getImageDimensions(defaultImage);
    setState((state) => ({
      ...state,
      src: defaultImage,
    }));
  };

  const aspectRatioWidthChangeHandler = (event) => {
    const aspectRatio = { ...state.aspectRatio };

    if (isNaN(event.target.value)) return;

    aspectRatio.width = parseInt(event.target.value);

    return setState((state) => ({
      ...state,
      aspectRatio: aspectRatio,
    }));
  };

  const aspectRatioHeightChangeHandler = (event) => {
    const aspectRatio = { ...state.aspectRatio };

    if (isNaN(event.target.value)) return;

    aspectRatio.height = parseInt(event.target.value);
    return setState((state) => ({
      ...state,
      aspectRatio: aspectRatio,
    }));
  };

  return (
    <div className="card-shadow">
      <div className="row" style={{ margin: "10px auto" }}>
        <div className="col-md-8">
          <input
            type="file"
            className="form-control form-control-sm img"
            onChange={onChange}
            accept="image/*"
          />
        </div>
        <div className="col-md-4 text-right">
          <button
            type="button"
            className="btn btn-default waves-effect waves-classic btn-sm"
            onClick={useDefaultImage}
            disabled={state.src === props.defaultImage}
          >
            <i
              className="icon md-camera animation-scale-up"
              aria-hidden="true"
            ></i>
            &nbsp;Original image
          </button>
        </div>
      </div>
      <div className="row" style={{ margin: "inherit" }}>
        <div className="col-md-12">
          <h4>Cropper aspect ratio:</h4>
          <div className="form-inline">
            <div className="form-group form-material">
              <label className="form-control-label" htmlFor="width">
                Width:
              </label>
              <input
                type="number"
                onChange={(event) => aspectRatioWidthChangeHandler(event)}
                value={state.aspectRatio.width ?? 80}
                className="form-control"
                id="width"
                autoComplete="off"
              />
            </div>
            <div className="form-group form-material">
              <label className="form-control-label" htmlFor="height">
                Height:
              </label>
              <input
                type="number"
                onChange={(event) => aspectRatioHeightChangeHandler(event)}
                value={state.aspectRatio.height ?? 80}
                className="form-control"
                id="height"
                autoComplete="off"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row" style={{ margin: "10px auto" }}>
        <div className="col-md-12">
          <Cropper
            guides={true}
            movable={false}
            style={{ width: "100%", height: "250px", marginBottom: "5px" }}
            aspectRatio={state.aspectRatio.width / state.aspectRatio.height}
            preview=".img-preview"
            src={state.src}
            ref={(ref) => (cropper = ref)}
          />
          <div className="text-center">
            <button
              type="button"
              onClick={cropImage}
              className="btn btn-raised btn-floating animation-slide-bottom waves-effect waves-classic"
            >
              <i
                className="icon md-crop animation-scale-up"
                aria-hidden="true"
              ></i>
            </button>
          </div>
          <div className="text-right">
            {props.id && (
              <button
                type="button"
                className="btn btn-default btn-pure"
                data-toggle="collapse"
                data-target={`#${props.id}`}
              >
                Close
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageCropper;
